import { VIEW_MODE_CHANNEL_BANNER } from '../constants/channels'

const LOCAL_STORAGE_CURRENT_CHANNEL_ID_KEY = 'LOCAL_STORAGE/CHANNELS/CURRENT_CHANNEL_ID'
const LOCAL_STORAGE_REQUESTED_VIEW_MODE_KEY = 'LOCAL_STORAGE/CHANNELS/REQUESTED_VIEW_MODE_KEY'
const LOCAL_STORAGE_CLOSED_CAPTIONS_PREFIX = 'LOCAL_STORAGE/CLOSED_CAPTIONS/CHANNEL/'

export const getCurrentFromPrograms = (programs) => {
  const now = Math.floor(Date.now() / 1000)
  return programs.find((program) => {
    return program.start <= now && now <= program.end
  })
}

export const getCurrentIndexFromPrograms = (programs) => {
  const now = Math.floor(Date.now() / 1000)
  return programs.findIndex((program) => {
    return program.start <= now && now <= program.end
  })
}

export const getFocusedPosition = (focusedPosition, currentPrograms) => {
  if (focusedPosition === -1) {
    focusedPosition = getCurrentIndexFromPrograms(currentPrograms)
  } else if (focusedPosition === -2) {
    focusedPosition = currentPrograms.length - 1
  }
  if (focusedPosition < 0 || focusedPosition >= currentPrograms.length) {
    focusedPosition = 0
  }
  return focusedPosition
}

export const getCurrentProgramsForInterval = (programs, from, to) => {
  const currentPrograms = programs.filter((program) => {
    return (from <= program.start && program.start < to)
      || (from < program.end && program.end <= to)
      || (program.start < from && program.end > to)
  })
  if (currentPrograms.length === 0) {
    currentPrograms.push(createDummyProgram(from, to))
  } else {
    if (currentPrograms[0].start - from > 1) {
      currentPrograms.unshift(createDummyProgram(from, currentPrograms[0].start))
    }
    if (to - currentPrograms[currentPrograms.length - 1].end > 1) {
      currentPrograms.push(createDummyProgram(currentPrograms[currentPrograms.length - 1].end, to))
    }
  }
  return currentPrograms
}

export const createDummyProgram = (start, end) => ({
  id: -1,
  name: '',
  desc: '',
  start: start,
  end: end,
  category: '',
  rating: {
    mpaa: '',
    tv: ''
  }
})

export const rememberChannelId = (id) => {
  localStorage.setItem(LOCAL_STORAGE_CURRENT_CHANNEL_ID_KEY, id)
}

export const getRememberedChannelId = () => {
  const savedChannelId = +localStorage.getItem(LOCAL_STORAGE_CURRENT_CHANNEL_ID_KEY)
  return savedChannelId || -1
}

export const requestChannelViewMode = (viewMode) => {
  localStorage.setItem(LOCAL_STORAGE_REQUESTED_VIEW_MODE_KEY, viewMode)
}

export const getRequestedViewMode = () => {
  const requestedViewMode = localStorage.getItem(LOCAL_STORAGE_REQUESTED_VIEW_MODE_KEY)
  return requestedViewMode || VIEW_MODE_CHANNEL_BANNER
}

export const formatChannelNumber = (no, length = 3) => {

  let formatted = ''
  for(let i = 1; i <= length - no.length; i++) {
    formatted += '0'
  }
  formatted += no

  return formatted
}

export const showClosedCaptionsForChannelId = (id) => {
  localStorage.setItem(LOCAL_STORAGE_CLOSED_CAPTIONS_PREFIX + id, 'yes')
}

export const hideClosedCaptionsForChannelId = (id) => {
  localStorage.removeItem(LOCAL_STORAGE_CLOSED_CAPTIONS_PREFIX + id)
}

export const getClosedCaptionsForChannelId = (id) => {
  return localStorage.getItem(LOCAL_STORAGE_CLOSED_CAPTIONS_PREFIX + id) === 'yes'
}
